import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { comprasRecientes } from '../data/notifications';
const FIRST_DELAY = 8000;
const INTERVAL = 15000;
const VISIBLE = 5000;
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    let hideTimer: number;
    const cycle = (delay: number) => {
      showTimer = window.setTimeout(() => {
        setVisible(true);
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % comprasRecientes.length);
          cycle(INTERVAL - VISIBLE);
        }, VISIBLE);
      }, delay);
    };
    cycle(FIRST_DELAY);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const compra = comprasRecientes[index];
  return <div aria-live="polite" className="pointer-events-none fixed inset-x-3 bottom-3 z-50 flex justify-center sm:inset-x-auto sm:bottom-5 sm:left-5 sm:justify-start" data-id="element-133" data-mp="ot38tgjcp9px">
      <AnimatePresence data-id="element-134" data-mp="evf90c6w1c0w">
        {visible && <motion.div key={`${compra.nombre}-${index}`} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-[300px] items-center gap-2 rounded-full border border-surface-line bg-white/95 py-1.5 pl-2 pr-1.5 shadow-card backdrop-blur" data-id="element-135" data-mp="ewqimsn0ldzx">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success text-white" data-id="element-136" data-mp="3nbqm5orsn3qe">
              <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-137" data-mp="3j8kj0pzz9so5" />
            </span>
            <p className="min-w-0 flex-1 truncate text-[11px] leading-tight text-ink" data-id="element-138" data-mp="3kru9d7zynqh4">
              <span className="font-bold text-ink-strong" data-id="element-139" data-mp="3pq5kdm1zs70x">{compra.nombre}</span>{' '}
              compró · {compra.ciudad.split(',')[0]}
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificaciones" className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-ink-muted transition-colors duration-150 ease-out hover:bg-surface-alt hover:text-ink-strong focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-brand" data-id="element-140" data-mp="3aupk2zatjew3">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-141" data-mp="2x0f0sxhlccxf" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}